import dynamic from 'next/dynamic';
export default dynamic(() =>
	import(/* webpackChunkName:"HeaderDesktop" */ './HeaderDesktop').then((mod) => mod.default)
);
